module.exports = __webpack_public_path__ + "img/close.87aaa8f2.svg";